module.exports = __webpack_public_path__ + "fontawesome-webfont.b06871f281fee6b241d6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 955
// module chunks = 7